export default __webpack_public_path__ + "static/media/logo-branco.7b6c68bd.png";